import React from 'react';
export function Section({
  children,
  className = '',
  id,
  variant = 'default'
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
  variant?: 'default' | 'alt';
}) {
  const bgClass = variant === 'alt' ? 'bg-brand-bgGradient/30' : '';
  return <section id={id} className={bgClass} data-id="element-352">
      <div className={`py-16 md:py-20 px-4 max-w-6xl mx-auto ${className}`} data-id="element-353">
        {children}
      </div>
    </section>;
}